export default __webpack_public_path__ + "static/media/roccos.KM.98d213ce.jpg";